import { isBefore, sub } from 'date-fns';
import * as yup from 'yup';

import { TITLES } from './Fields/FullNameField/FullNameField';

const phoneNumberRegexDE = /^(0|(\+49)|0049)[0-9]{8,15}$/;
const postcodeRegexDE = /^[0-9]{2}[0-9]{3}$/;
const dayRegex = /\b(0?[1-9]|[1-2][0-9]|[3][0-1])\b/;
const monthRegex = /^(?:0?[1-9]|1[012])$/;

export const schema = yup.object().shape({
  title: yup.string<(typeof TITLES)[number]['value']>().required('benötigt'),
  firstName: yup.string().required('benötigt'),
  lastName: yup.string().required('benötigt'),
  dobDay: yup
    .string()
    .required('benötigt')
    .matches(dayRegex, 'ungültige Eingabe'),
  dobMonth: yup
    .string()
    .required('benötigt')
    .matches(monthRegex, 'ungültige Eingabe'),
  dobYear: yup
    .string()
    .min(4, 'benötigt')
    .max(4, 'ungültige Eingabe')
    .required('benötigt')
    .test(
      'Is 18 or over',
      'Mindestalter 18 Jahre',
      function (value, testContext) {
        if (
          !Number(testContext.parent.dobMonth) ||
          !Number(testContext.parent.dobDay)
        ) {
          // Don't check age unless day + month entered
          return true;
        }
        return isOver18(
          value,
          testContext.parent.dobMonth,
          testContext.parent.dobDay,
        );
      },
    ),
  streetLine1: yup.string().required('benötigt'),
  houseNumber: yup.string().required('benötigt'),
  streetLine2: yup.string(),
  postcode: yup
    .string()
    .required('benötigt')
    .test('Is a valid postcode', 'ungültige Eingabe', function (value) {
      return isValidPostcode(value);
    }),
  town: yup.string().required('benötigt'),
  phoneNumber: yup
    .string()
    .required('benötigt')
    .test('Is a valid number', 'ungültige Eingabe', function (value) {
      return isValidNumber(value);
    }),
  privacyPolicyAgreement: yup
    .boolean()
    .required('benötigt')
    .oneOf([true], 'benötigt'),
});

export const minimumPersonalDataSchemaDE = yup.object().shape({
  title: yup.string().required(),
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  dobDay: yup.string().required().matches(dayRegex),
  dobMonth: yup.string().required().matches(monthRegex),
  dobYear: yup
    .string()
    .min(4)
    .max(4)
    .required()
    .test('Is 18 or over', function (value, testContext) {
      if (
        !Number(testContext.parent.dobMonth) ||
        !Number(testContext.parent.dobDay)
      ) {
        // Don't check age unless day + month entered
        return true;
      }
      return isOver18(
        value,
        testContext.parent.dobMonth,
        testContext.parent.dobDay,
      );
    }),
  streetLine1: yup.string().required(),
  houseNumber: yup.string().required(),
  postcode: yup
    .string()
    .required()
    .test('Is a valid postcode', function (value) {
      return isValidPostcode(value);
    }),
  town: yup.string().required(),
  phoneNumber: yup
    .string()
    .required()
    .test('Is a valid number', function (value) {
      return isValidNumber(value);
    }),
  privacyPolicyAgreement: yup.boolean().required().oneOf([true]),
});

const isOver18 = (year: string, month: string, day: string) => {
  const date18YearsAgo = sub(new Date(), { years: 18 });

  return isBefore(
    new Date(parseInt(year), parseInt(month), parseInt(day)),
    date18YearsAgo,
  );
};

const isValidPostcode = (value: string) => {
  return postcodeRegexDE.test(value);
};

const isValidNumber = (value: string) => {
  const whitespaceRemoved = value.replace(/\(|\)|\s+|-|\//g, '');
  return phoneNumberRegexDE.test(whitespaceRemoved);
};
